<template>
  <div v-if="data.length > 0" :class="['flex w-full justify-start', name && 'py-2']">
    <span
      v-if="name"
      class="mr-2.5 mt-1 text-xl font-bold text-white lg:-mt-0.5 max-lg:text-xs max-lg:leading-[1.125rem] max-lg:h-5.5 max-lg:inline-flex max-lg:items-center"
    >
      {{ name }}:
    </span>
    <div class="inline-flex flex-wrap">
      <GfrTooltip
        v-for="(item, index) in data"
        :key="index"
        :message="item.hover"
        type="arrow"
        :offset-y="0"
        :placement="'bottom-center'"
        class="mr-2.5"
        content-class="max-w-60 text-center"
        v-slot="slotProps"
      >
        <GfrTag :class="[formatClassName, item.link && 'has_link', 'my-1']" :link="item.link">
          {{ item.name }}
        </GfrTag>
      </GfrTooltip>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { DocumentTag } from '~/server/types'

const props = defineProps({
  data: {
    type: Array as PropType<DocumentTag[]>,
    default: () => []
  },
  type: String,
  name: String
})
const formatClassName = computed(() => {
  return props.type?.replace(/_/g, '-')
})
</script>
